import { render, staticRenderFns } from "./settingDobare.vue?vue&type=template&id=30347d64&scoped=true&"
import script from "./settingDobare.vue?vue&type=script&lang=js&"
export * from "./settingDobare.vue?vue&type=script&lang=js&"
import style0 from "./settingDobare.vue?vue&type=style&index=0&id=30347d64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30347d64",
  null
  
)

export default component.exports